

import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { Support } from "../../../../Component/Model/Dto/Support/SupportRequest";
import { removeHtmlAndTrim, TableDateHelper } from "../../../../Component/Model/helpers";
import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";

interface TicketFeedbackRow {
    CreatedBy: string;
    CreatedDate: string;
    Documents: string;
    Message: string;
    Actions?: ActionType[];
}

export interface TicketFeedbackTable {
    columns: Array<TableColumn>;
    rows: Array<TicketFeedbackRow>;
}

export function TicketFeedbackTableMapper(results: Support.TicketFeedbackDtoOut[], onViewFeedback: (id: number) => void): TicketFeedbackTable {

    const columns = [
        { Header: 'Created By', accessor: 'CreatedBy', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Created Date', accessor: 'CreatedDate', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Documents', accessor: 'Documents', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Message', accessor: 'Message', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (results.length >= 0) {

        const rows = results.map((item: Support.TicketFeedbackDtoOut, index: number) => (
            {
                CreatedBy: item.CreatedBy,
                CreatedDate: TableDateHelper(item.CreatedDate.toString()),
                Documents: item.Documents.length.toString(),
                Message: removeHtmlAndTrim(item.Message,50),
                Actions: [
                    {
                        key: index.toString(),
                        label: 'View feedback',
                        action: () => {
                            onViewFeedback(item.Id);
                        },
                        icon: {
                            color: 'info',
                            name: 'visibility'
                        }
                    }
                ]
            }));

        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}